import { FC } from 'react'
import { Dimensions, ListRenderItemInfo } from 'react-native'
import { ColorsEnum } from '../../constants/colors'
import { stationColumns, StationTypesEnum } from '../../constants/stations'
import { useAppSelector } from '../../hooks/redux'
import { appSelectors } from '../../redux/reducers/app'
import { stationSelectors } from '../../redux/reducers/station'
import { IColumn } from '../../types/column'
import CustomerOrderColumn from '../Customer/CustomerOrderColumn'
import Columns from '../UI/Columns/Columns'
import OrderColumn from './OrderColumn'

const OrderColumns: FC = () => {
    const isArchive = useAppSelector(appSelectors.isArchive)
    const currentStation = useAppSelector(stationSelectors.currentStation)

    if (!currentStation) {
        return <></>
    }

    const section = !isArchive ? 'active' : 'archive'
    const columns = stationColumns[currentStation.type][section]!

    const width = Math.min(Dimensions.get('window').width / columns.length, 600)

    const renderColumn = ({ item: column }: ListRenderItemInfo<IColumn>) => {
        if (currentStation.type === StationTypesEnum.CUSTOMER_STATION) {
            return (
                <CustomerOrderColumn
                    key={column.id}
                    id={column.id}
                    stationStates={column.stationStates}
                    states={column.states}
                    title={column.name}
                    width={column.width ?? width}
                    style={{ backgroundColor: ColorsEnum.GRAY_LIGHT }}
                />
            )
        }

        return (
            <OrderColumn
                key={column.id}
                id={column.id}
                stationStates={column.stationStates}
                states={column.states}
                title={column.name}
                width={width}
                style={{ backgroundColor: ColorsEnum.GRAY_LIGHT }}
            />
        )
    }

    return (
        <Columns
            data={columns}
            renderColumn={renderColumn}
            style={{ backgroundColor: ColorsEnum.GRAY_LIGHT }}
        />
    )
}

export default OrderColumns
